import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus() {
  var result = Complex.createComplex(1, 0);
  return result;
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
